import { GridColumnConfig } from '../../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: ' Title',
    field: 'contactsTitle',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Contact Name',
    field: 'contactsFullName',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Description',
    field: 'contactsDescription',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Work Email',
    field: 'contactsWorkEmail',
    filter: 'text',
    searchable: true,
    width: '320',
  },
  {
    title: 'Other Email',
    field: 'contactsSecondaryEmail',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Office Phone',
    field: 'contactsOfficePhone',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Cell Phone',
    field: 'contactsCellPhone',
    filter: 'text',
    searchable: true,
  },
  {
    title: ' Role',
    field: 'contactsRoleName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Master contact',
    field: 'masterContacts',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Special Instruction',
    field: 'specialInstructions',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'contactsStatus',
    filter: 'text',
    searchable: true,
  },
];
